import React from 'react';
import { Link } from 'react-router-dom';
import MuscleRecoveryMap from '../../MuscleRecoveryMap';

/**
 * BodyMapCard — chat card rendering the muscle recovery map. Thin wrapper
 * over the shared <MuscleRecoveryMap /> so the chat and the Recovery page
 * always render the same silhouette (full-green when no data — single
 * source of truth, no duplicate "fresh defaults" trick).
 */
const BodyMapCard = ({ data }) => {
  const muscles = data?.muscle_groups || {};
  const hasData = Object.keys(muscles).length > 0;
  return (
    <Link
      to="/recovery"
      className="block rounded-sm border border-zinc-700 bg-zinc-900/40 p-3 hover:border-primary transition-colors max-w-[320px]"
      data-testid="card-body-map"
    >
      <div className="flex items-center justify-between mb-1">
        <p className="text-[10px] text-zinc-500 uppercase tracking-wider">Muscle recovery</p>
        {!hasData && <span className="text-[10px] text-green-400">All fresh</span>}
      </div>
      <div className="flex items-center justify-center" style={{ height: 160 }}>
        <MuscleRecoveryMap muscleData={muscles} size="sm" showLabels={false} interactive={false} />
      </div>
      <p className="text-[10px] text-primary mt-1 text-right">Open Recovery →</p>
    </Link>
  );
};

export default BodyMapCard;
